import { createNamedStyles } from "../../../shared/CreateNamedStyles";

export const SectionHeadStyles = createNamedStyles({
  root: {
    textAlign: "left",
    marginBottom: "32px",
  },
});
